var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.className,attrs:{"href":"javascript:;","r-eid":_vm.rEid},on:{"click":_vm.click}},[_vm._t("default",[_c('span',[_vm._v("按钮")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }